export const EZ_READER_ACTIVITY_TYPE = 'Drug Screen - EZ-Reader';

export const EZ_READER_CONTRACT_ASSIGN_ERROR =
  'Only one EZ Reader has been assigned to this contract.';

export const EZ_READER_VISIT_LIMIT_ERROR =
  'Only one EZ Reader activity is allowed for this visit.';

export const isEzReaderActivityType = (activityType) =>
  activityType === EZ_READER_ACTIVITY_TYPE;
